module.exports = __webpack_public_path__ + "assets/img/18_1876.747582d3.jpg";